module.exports = __webpack_public_path__ + "img/Body_MetalRoughness.2e2573d.jpg";